import { render, staticRenderFns } from "./lv-radish-list.vue?vue&type=template&id=1c931510&scoped=true"
import script from "./lv-radish-list.vue?vue&type=script&lang=js"
export * from "./lv-radish-list.vue?vue&type=script&lang=js"
import style0 from "./lv-radish-list.vue?vue&type=style&index=0&id=1c931510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c931510",
  null
  
)

export default component.exports